<template>
    <label v-if="label" for="label">{{ label }}</label>
    <div class="flex flex-column justify-content-center gap-3">
        <div v-for="option in options" :key="option.id" class="flex align-items-center">
            <Checkbox v-if="type == types.CHECKBOX" v-model="optionModel" :name="option.value" :value="option.value" />
            <RadioButton v-else v-model="optionModel" :name="option.value" :value="option.value" />
            <label :for="option.value" class="ml-2"> {{ option.label }} </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SelectionInput',
    props: {
        label: {
            type: String,
        },
        type: {
            type: String,
        },
        types: {
            type: Object,
        },
        attributeOptions: {
            type: Array,
        },
    },
    data() {
        return {
            options: [],
            optionModel: null,
        };
    },
    created() {
        this.options = this.attributeOptions;
    },
};
</script>
